import React, { useState, useEffect, useMemo } from 'react'
import FormRule from './FormRule'
import '../../styles/index.scss'
import { Link } from 'react-router-dom'
import { getRuleDetails, listPartner as fetchPartner, listSku, updateRule, createRule } from '../../../../services/api/3dApi'
import { message, Button, Spin } from 'antd'
import queryString from 'query-string'
import getHistory from '../../../../helpers/rounting/getHistory'
import moment from 'moment'
import { v4 as uuidV4 } from 'uuid'
import { size_of_raw_materials, size_frames } from '../../constant/config'

function UpdateRuleContainer(props) {
    const [ruleDetails, setRuleDetails] = useState({})
    const [loading, setLoading] = useState(false)

    const { _id: ruleId } = { ...ruleDetails }
    const [priority, setPriority] = useState('')
    const [partner, setPartner] = useState('')
    const [stores, setStores] = useState({ mode: 'exclude' })
    const [tags, setTags] = useState({ mode: 'exclude' })
    const [onlyStore, setOnlyStore] = useState(false)
    const [onlyPackage, setOnlyPackage] = useState(false)
    const [status, setStatus] = useState(false)
    const [schedule, setSchedule] = useState({})
    const [products, setProducts] = useState({ mode: 'exclude' })
    const [validate, setValidate] = useState({})
    const [errors, setErrors] = useState('')
    const [allPartners, setListPartner] = useState([])
    const [allSku, setAllSku] = useState([])
    const [location, setLocation] = useState('')
    const [isFit, setIsFit] = useState(false)
    const [splitByPack, setSplitByPack] = useState(false)
    const [isMultiVariants, setIsMultiVariants] = useState(false)
    const [isMultiFrames, setIsMultiFrames] = useState(false)
    const [variants, setVariants] = useState([{
        name: '__ALL_SIZE__',
        sizes: [],
        min_variant_quantity: null,
        conditions: [],
        key: '1',
        is_multi_sizes: false,
    }])
    const [fitCondition, setFitCondition] = useState({})
    const [isMultiBrands, setIsMultiBrands] = useState(false)
    const [isMultiSizes, setIsMultiSizes] = useState(false)
    const [sizeFrames, setSizeFrames] = useState(size_frames)
    const [sizeOfRawMaterials, setSizeOfRawMaterials] = useState(size_of_raw_materials)

    const format = 'HH:mm'

    const handleAddSizeFrames = (value) => {
        setSizeFrames(preState => {
            const newSizeFrames = [...preState, value]
            const sortedSizeFrames = newSizeFrames.sort((a, b) => {
                if (a.h !== b.h) {
                    return b.h - a.h
                }
                return b.w - a.w
            })
            return sortedSizeFrames
        })
    }

    const handleAddSizeRawMaterials = (value) => {
        setSizeOfRawMaterials(preState => {
            const newSizeRawMaterials = [...preState, value]
            const sortedSizeRawMaterials = newSizeRawMaterials.sort((a, b) => {
                if (a.h !== b.h) {
                    return b.h - a.h
                }
                return b.w - a.w
            })
            return sortedSizeRawMaterials
        })
    }

    const handleChangeVariant = (tabKey, field, value, isCodition = false, indexCodition) => {
        const newVariants = variants.map((variant) => {
            if (tabKey === variant.key) {
                if (isCodition) {
                    const newConditions = variant.conditions.map((codition, i) => {
                        if (i === indexCodition) {
                            return {
                                ...codition,
                                [field]: value
                            }
                        }
                        return codition
                    })
                    return {
                        ...variant,
                        conditions: newConditions
                    }
                }

                if (field === "sizes") {
                    const newValue = Array.from(new Set(value.map(i => !!i && i.trim()).filter(Boolean)))
                    return {
                        ...variant,
                        [field]: newValue
                    }
                }
                return {
                    ...variant,
                    [field]: value
                }
            }
            return variant
        })

        setVariants(newVariants)
    }

    const addCondition = (tabKey) => {
        const newVariants = variants.map(variant => {
            if (variant.key === tabKey) {
                const { conditions = [] } = { ...variant }
                const newConditions = [...conditions, {}]

                return {
                    ...variant,
                    conditions: newConditions
                }
            }

            return variant
        })

        setVariants(newVariants)
    }

    const removeRecord = (tabKey, index) => {
        const newVariants = variants.map(variant => {
            if (variant.key === tabKey) {
                const { conditions = [] } = { ...variant }
                const newConditions = conditions.filter((c, i) => i !== index)
                return {
                    ...variant,
                    conditions: newConditions
                }
            }

            return variant
        })

        setVariants(newVariants)
    }

    const handleChangeRecord = (tabKey, field, value, index) => {
        setVariants(preState => {
            return preState.map(variant => {
                if (tabKey === variant.key) {
                    const { conditions = [] } = { ...variant }
                    const newConditions = conditions.map((c, i) => {
                        if (i === index) {
                            if (field === "frame" && !!value) {
                                const [w = 0, h = 0] = value.split('x') || []
                                return {
                                    ...c,
                                    frame: {
                                        ...c.frame,
                                        type: isFit ? 'area' : 'quantity',
                                        w: +w,
                                        h: +h,
                                        label: value,
                                    },
                                    max_per_batch: (w && h) ? w * h : 0
                                }
                            }

                            return {
                                ...c,
                                [field]: value
                            }
                        }
                        return c
                    })

                    return {
                        ...variant,
                        conditions: newConditions
                    }
                }

                return variant
            })
        })
    }

    const addFitCondition = (field) => {
        setFitCondition(pre => {
            const { coverages = [], frames = [] } = Object.assign({}, pre)
            if (field === "coverages") {
                const newCoverages = [...coverages, { _idx: uuidV4() }]
                return { ...pre, coverages: newCoverages }
            }

            if (field === "frames") {
                const newFrames = [...frames, { _idx: uuidV4() }]
                return { ...pre, frames: newFrames }
            }

            return pre
        })
    }

    const removeFitCondition = (field, idCondition) => {
        setFitCondition(pre => {
            const { coverages = [], frames = [] } = Object.assign({}, pre)
            if (field === "coverages") {
                const newCoverages = coverages.filter(c => c._idx !== idCondition)
                return { ...pre, coverages: newCoverages }
            }

            if (field === "frames") {
                const newFrames = frames.filter(c => c._idx !== idCondition)
                return { ...pre, frames: newFrames }
            }

            return pre
        })
    }

    const handleChangeFitCondition = (idCondition, field, value, fieldParent) => {
        setFitCondition(pre => {
            const { coverages = [], frames = [] } = Object.assign({}, pre)
            if (fieldParent === "coverages") {
                const newCoverages = coverages.map(cr => {
                    if (cr._idx === idCondition) {
                        return { ...cr, [field]: value }
                    }

                    return cr
                })
                return { ...pre, coverages: newCoverages }
            }

            if (fieldParent === "frames") {
                const newFrames = frames.map(fr => {
                    if (fr._idx === idCondition) {
                        if (field === "type") {
                            const [w = 0, h = 0] = value ? value.split('x') : []
                            return {
                                ...fr,
                                type: isFit ? 'area' : 'quantity',
                                w: +w,
                                h: +h,
                                label: value ? value : ''
                            }
                        }

                        return { ...fr, [field]: value }
                    }

                    return fr
                })
                return { ...pre, frames: newFrames }
            }

            return pre
        })
    }

    const getListPartner = async () => {
        const payload = {
            limit: 10000,
            page: 1,
            hidden: false,
        }
        try {
            const query = queryString.stringify(payload)
            const { data: Data } = await fetchPartner(query)
            const { data, success, message } = Data
            if (success) {
                setListPartner(data.partners)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getListSku = async () => {
        const payload = {
            limit: 10000,
            page: 1,
            hidden: false,
        }
        try {
            const query = queryString.stringify(payload)
            const { data: Data } = await listSku(query)
            const { data, success, message } = Data
            if (success) {
                const regex = /\s/
                const newData = data.length > 0 && data.filter((item) => {
                    return !regex.test(item.sku) && item
                })
                setAllSku(newData)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const isUpdate = (() => {
        const { match } = props
        const { id } = match.params

        return id
    })()

    const fetchRuleDetails = async () => {
        setLoading(true)
        setVariants([{
            name: '__ALL_SIZE__',
            sizes: [],
            min_variant_quantity: null,
            conditions: [],
            key: '1',
            is_multi_sizes: false,
        }])
        setFitCondition({})

        try {
            const { match } = props
            const { id } = match.params

            const { data: response } = await getRuleDetails(id)
            const { success, message: error, data } = response

            if (!success) throw new Error(error)
            const {
                priority,
                partner,
                schedule,
                location,
                only_store,
                only_package,
                is_active,
                products,
                stores,
                required_tags,
                is_fit,
                is_multi_variants = false,
                is_multi_frames = false,
                fit_condition = {},
                variants: variantsData = [],
                is_multi_brands = false,
            } = { ...data }

            setRuleDetails(data)
            if (priority) setPriority(priority)
            if (Object.keys(partner)) setPartner(partner._id)
            if (schedule) setSchedule(schedule)
            if (location) setLocation(location)
            setOnlyStore(only_store)
            setOnlyPackage(only_package)
            setStatus(is_active)
            setIsMultiBrands(is_multi_brands)
            setIsMultiSizes(!!variantsData.length && !!variantsData[0] && (variantsData[0].is_multi_sizes || false))
            setProducts(products)
            setStores(stores)
            setTags(required_tags)
            setIsFit(is_fit)
            setIsMultiVariants(is_multi_variants)
            setIsMultiFrames(is_multi_frames)
            if (!!Object.keys(fit_condition).length) {
                const { frames = [], coverages = [], split_by_pack = false } = Object.assign({}, fit_condition)
                const newFrames = frames.map(fr => ({ ...fr, _idx: uuidV4(), label: (fr.w && fr.h) ? `${fr.w}x${fr.h}` : '' }))
                const newCoverages = coverages.map(cr => ({ ...cr, _idx: uuidV4() }))
                setFitCondition({ ...fit_condition, frames: newFrames, coverages: newCoverages })
                setSplitByPack(split_by_pack)
            }
            if (variantsData.length > 0) {
                const newVariants = variantsData.map((variant, index) => {
                    const { conditions = [], is_multi_sizes = false } = Object.assign({}, variant)
                    const newConditions = conditions.map((condition) => {
                        const { partner = {}, frame = {}, max_per_batch = 0 } = Object.assign({}, condition)
                        const newFrame = {
                            ...frame,
                            label: (frame.w && frame.h) ? `${frame.w}x${frame.h}` : ''
                        }
                        return {
                            ...condition,
                            frame: newFrame,
                            partner: !!partner._id ? partner._id : '',
                            max_per_batch: is_multi_frames ? ((frame.w && frame.h) ? frame.w * frame.h : 0) : max_per_batch
                        }
                    })
                    return {
                        ...variant,
                        key: `${index + 1}`,
                        conditions: newConditions,
                        is_multi_sizes,
                    }
                })

                setVariants(newVariants)
            }

        } catch (e) {
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleChangeInput = (name, e) => {
        const { value } = e.target
        delete validate[name]
        setValidate(validate)
        if (name === 'priority') {
            setPriority(parseFloat(value))
        }
    }

    const handleChangeOnlyStore = (value) => {
        setOnlyStore(value)
    }

    const handleChangeOnlyPackage = (value) => {
        setOnlyPackage(value)
    }

    const handleChangeActive = (value) => {
        setStatus(value)
    }

    const handleChangeMultiBrand = (value) => {
        setIsMultiBrands(value)
    }

    const handleChangeMultiSize = (value) => {
        setIsMultiSizes(value)
    }

    const handleChangeIsFit = (value) => {
        setIsFit(value)
        setIsMultiVariants(false)
        setIsMultiFrames(false)
        setSplitByPack(false)
        setVariants([{
            name: '__ALL_SIZE__',
            sizes: [],
            min_variant_quantity: null,
            conditions: [],
            key: '1',
            is_multi_sizes: false,
        }])
        setFitCondition({})
    }

    const handleChangeSplitByPack = (value) => {
        setSplitByPack(value)
    }

    const handleChangeMultiVariants = (value) => {
        setIsMultiVariants(value)
        setIsMultiFrames(false)
        setIsMultiSizes(false)
    }

    const handleChangeMultiFrames = (value) => {
        setIsMultiFrames(value)

        const newVariants = variants.map(variant => {
            const { conditions = [] } = { ...variant }
            const newConditions = conditions.map(condition => {
                const { frame = {} } = { ...condition }
                const newMaxPerBatch = (!!frame.w && !!frame.h) ? frame.w * frame.h : null
                return {
                    ...condition,
                    max_per_batch: !!value ? newMaxPerBatch : null,
                }
            })
            return { ...variant, conditions: newConditions }
        })
        setVariants(newVariants)
    }

    const onChangeSelect = (name, e) => {
        delete validate[name]
        setValidate(validate)

        if (name === 'partner') setPartner(e)
        if (name === 'product') setProducts({ ...products, mode: e })
        if (name === 'sku') setProducts({ ...products, sku: e })
        if (name === 'stores') setStores({ ...stores, mode: e })
        if (name === 'tags') setTags({ ...tags, mode: e })
        if (name === 'location') setLocation(e)
    }

    const onChangeTime = (name, value) => {
        delete validate[name]
        setValidate(validate)
        if (name === 'start') setSchedule({ ...schedule, start: value })
        if (name === 'end') setSchedule({ ...schedule, end: value })
    }

    const handleSave = async () => {
        setErrors('')
        if (Validate()) return
        const payload = {
            priority: priority,
            partner: partner,
            schedule: schedule,
            only_store: onlyStore,
            only_package: onlyPackage,
            is_active: status,
            is_fit: isFit,
            is_multi_brands: isMultiBrands,
        }
        if (!!location) payload.location = location
        if (!!products && !!Object.keys(products).length) payload.products = {
            ...products,
            sku: !!products.sku ? products.sku.filter(i => allSku.some(o => !!o.sku && !!i && o.sku.trim() === i.trim())).map(item => item.trim()) : []
        }
        if (!!stores && !!Object.keys(stores).length) payload.stores = stores
        if (!!tags && !!Object.keys(tags).length) payload.required_tags = tags

        if (!isFit) {
            payload.is_multi_variants = isMultiVariants
            payload.is_multi_frames = isMultiFrames
            if (isMultiVariants) {
                if (!isMultiFrames) {
                    payload.variants = variants.map(variant => {
                        const { conditions = [], min_variant_quantity, is_multi_sizes = false, ...restVariant } = { ...variant }
                        const newConditions = conditions.map(condition => {
                            const { min, max, partner, min_per_batch, max_per_batch = 0, is_enable = false, user_prefix = '' } = { ...condition }
                            return {
                                min: +min,
                                max: +max,
                                partner,
                                min_per_batch: +min_per_batch,
                                max_per_batch: +max_per_batch,
                                is_enable,
                                user_prefix
                            }
                        })

                        return { ...restVariant, conditions: newConditions, is_multi_sizes }
                    })
                } else {
                    payload.variants = variants.map(variant => {
                        const { conditions, is_multi_sizes = false, ...restVariant } = { ...variant }
                        const newConditions = conditions.map(condition => {
                            const { frame, partner, max_per_batch = 0, is_enable = false, user_prefix = '' } = condition
                            const { w = 0, h = 0 } = { ...frame }
                            return {
                                frame: {
                                    type: isFit ? 'area' : 'quantity',
                                    w: +w,
                                    h: +h
                                },
                                partner,
                                max_per_batch: +max_per_batch,
                                is_enable,
                                user_prefix: !!user_prefix ? user_prefix.trim() : ''
                            }
                        })
                        return { ...restVariant, conditions: newConditions, is_multi_sizes }
                    })
                }
            } else {
                payload.variants = variants.map(variant => {
                    const { conditions = [], min_variant_quantity, ...restVariant } = { ...variant }
                    const newConditions = conditions.map(condition => {
                        const { min, max, partner, min_per_batch, max_per_batch = 0, is_enable = false, user_prefix = '' } = { ...condition }
                        return {
                            min: +min,
                            max: +max,
                            partner,
                            min_per_batch: +min_per_batch,
                            max_per_batch: +max_per_batch,
                            is_enable,
                            user_prefix
                        }
                    })

                    return { ...restVariant, conditions: newConditions, is_multi_sizes: isMultiSizes || false }
                })
            }
        } else {
            if (!!Object.keys(fitCondition).length) {
                const { frames = [], coverages = [] } = { ...fitCondition }
                const newFrames = frames.map(fr => {
                    const { w = 0, h = 0, is_enable = false } = { ...fr }
                    return {
                        type: isFit ? 'area' : 'quantity',
                        w: +w,
                        h: +h,
                        is_enable
                    }
                })
                const newCoverages = coverages.map(cr => {
                    const { rate = 0, partner = '', is_enable = false } = { ...cr }
                    return {
                        rate: +rate,
                        partner,
                        is_enable
                    }
                })
                payload.fit_condition = {
                    ...fitCondition,
                    frames: newFrames,
                    coverages: newCoverages,
                    split_by_pack: splitByPack ? true : false,
                }
            }
        }

        if (!!ruleId) {
            try {
                const { data: res } = await updateRule(ruleId, payload)
                const { success, error: mess } = res
                if (!success) {
                    throw new Error(mess)
                }
                message.success('Rule updated!!!')
                setErrors('')
                setProducts(preState => ({
                    ...preState,
                    sku: preState.sku.filter(i => allSku.some(o => !!o.sku && !!i && o.sku.trim() === i.trim())).map(item => item.trim())
                }))
            } catch (error) {
                message.error(error.message)
                setErrors(error.message)
            }
        } else {
            try {
                const { data: res } = await createRule(payload)
                const { success, error: mess } = res
                if (!success) {
                    throw new Error(mess)
                }
                message.success('Rule created!!!')
                const history = getHistory()
                //history.push(`/list-rule-create-batch`)
                history.push(`/edit-rule/${res.data._id}`)
                setErrors('')
            } catch (error) {
                message.error(error.message)
                setErrors(error.message)
            }
        }
    }

    const handleChangeTagMode = (name, value) => {
        delete validate[name]
        setValidate(validate)
        if (name === 'stores') setStores({ ...stores, list: [...value] })
        if (name === 'tags') setTags({ ...tags, tags: [...value] })
    }

    const Validate = () => {
        const errorValidate = {}
        if (!priority) {
            errorValidate.priority = 'Please input priority!!!'
        }
        if (!!priority && !Number.isInteger(parseInt(priority))) {
            errorValidate.priority = 'Invalid priority.'
        }
        if (!partner) {
            errorValidate.partner = 'Please select Partner!!!'
        }
        if (!schedule.start) {
            errorValidate.start = 'Please select time start!!!'
        }
        if (!!schedule && !!schedule.start && !!schedule.end) {
            const start = moment(schedule.start, format)
            const end = moment(schedule.end, format)
            if (end.isBefore(start)) {
                errorValidate.end = 'Please select time after time start!!!'
            }
        }
        if (!!products && products.mode !== 'exclude' && !products.sku) {
            errorValidate.sku = 'Please select sku!!!'
        }
        if (!!stores && stores.mode !== 'exclude' && !stores.list) {
            errorValidate.stores = 'Please input stores!!!'
        }
        if (!!tags && tags.mode !== 'exclude' && !tags.tags) {
            errorValidate.tags = 'Please input tags!!!'
        }

        setValidate(errorValidate)
        if (!!Object.keys(errorValidate).length) {
            return true
        }

        if (!isMultiFrames && !!variants.length && variants.some(variant => {
            const { conditions = [] } = Object.assign({}, variant)
            return conditions.some(condition => {
                const { min, max} = { ...condition }
                return !min|| !max
            })
        })) {
            message.error('Cần nhập đủ Số item tối thiểu và Số item tối đa.')
            return true
        }
        
        return false
    }

    const handleDragEnd = (result, field, activeKey) => {
        if (!result.destination) return

        if (field === "conditions") {
            setVariants(preVariant => {
                return preVariant.map(variant => {
                    if (variant.key === activeKey) {
                        const { conditions = [] } = variant
                        const items = [...conditions]

                        const [reorderedItem] = items.splice(result.source.index, 1)
                        items.splice(result.destination.index, 0, reorderedItem)

                        return { ...variant, conditions: items }
                    }
                    return variant
                })
            })
        } else {
            const data = fitCondition[field] ? fitCondition[field] : []
            const items = Array.from(data)
            const [reorderedItem] = items.splice(result.source.index, 1)
            items.splice(result.destination.index, 0, reorderedItem)

            setFitCondition({ ...fitCondition, [field]: items })
        }
    }

    useEffect(() => {
        isUpdate && fetchRuleDetails()
    }, [isUpdate])

    useEffect(() => {
        getListPartner()
        getListSku()
    }, [])

    const showForm = isUpdate && !!Object.keys(ruleDetails).length || !isUpdate

    return (
        <Spin spinning={loading}>
            <div className="UpdateRuleContainer">
                <div>
                    <div className="col-12 mx-auto bg-white shadow-sm py-3">
                        <div className="BackWrapper d-flex align-items-center">
                            <Link to="/list-rule-create-batch"><i className="fa fa-chevron-left" /> Danh sách Rule</Link>
                        </div>
                        <div className="mb-2 d-flex justify-content-between mt-3">
                            <h3 className="mb-0">{
                                isUpdate ? 'Chi tiết rule' : 'Tạo rule'
                            }</h3>
                            <div className="Actions">
                                <div className="d-flex align-items-center justify-content-end">
                                    <div>
                                        <Link
                                            className="mr-4 btn btn-secondary px-4"
                                            to="/list-rule-create-batch"
                                        >
                                            Hủy
                                        </Link>
                                        <button className='btn btn-primary px-4' onClick={handleSave}>Lưu</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            showForm &&
                            <FormRule
                                format={format}
                                validate={validate}
                                schedule={schedule}
                                onChangeTime={onChangeTime}
                                location={location}
                                onChangeSelect={onChangeSelect}
                                onlyStore={onlyStore}
                                onChangeOnlyStore={handleChangeOnlyStore}
                                onlyPackage={onlyPackage}
                                onChangeOnlyPackage={handleChangeOnlyPackage}
                                status={status}
                                onChangeActive={handleChangeActive}
                                products={products}
                                allSku={allSku}
                                stores={stores}
                                tags={tags}
                                onChangeTagMode={handleChangeTagMode}
                                isFit={isFit}
                                onChangeIsFit={handleChangeIsFit}
                                splitByPack={splitByPack}
                                onChangeSplitByPack={handleChangeSplitByPack}
                                isMultiVariants={isMultiVariants}
                                onChangeMultiVariants={handleChangeMultiVariants}
                                isMultiFrames={isMultiFrames}
                                onChangeMultiFrames={handleChangeMultiFrames}
                                variants={variants}
                                setVariants={setVariants}
                                onChangeVariant={handleChangeVariant}
                                priority={priority}
                                onChangeInput={handleChangeInput}
                                partner={partner}
                                allPartners={allPartners}
                                removeRecord={removeRecord}
                                addCondition={addCondition}
                                handleChangeRecord={handleChangeRecord}
                                fitCondition={fitCondition}
                                addFitCondition={addFitCondition}
                                removeFitCondition={removeFitCondition}
                                onChangeFitCondition={handleChangeFitCondition}
                                errors={errors}
                                handleDragEnd={handleDragEnd}
                                onChangeMultiBrand={handleChangeMultiBrand}
                                isMultiBrands={isMultiBrands}
                                onChangeMultiSize={handleChangeMultiSize}
                                isMultiSizes={isMultiSizes}
                                onAddSizeFrames={handleAddSizeFrames}
                                sizeFrames={sizeFrames}
                                onAddSizeRawMaterials={handleAddSizeRawMaterials}
                                sizeOfRawMaterials={sizeOfRawMaterials}
                            />
                        }
                    </div>
                </div>
            </div>
        </Spin>
    )
}

export default UpdateRuleContainer